import type { IconData } from '@stacksjs/iconify-core'

export const shoppingCartAdd: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M3.007 5.528C3.054 4.062 4.324 3 5.791 3h4.19a5 5 0 0 1 4.766 3.485L16.5 12h23.98c2.402 0 4.263 2.104 3.829 4.466c-.813 4.428-2.027 9.126-3.39 12.997c-.581 1.647-1.947 2.846-3.68 3.066c-1.866.238-4.823.471-9.24.471c-4.286 0-7.29-.22-9.262-.45c-1.95-.227-3.47-1.625-4.062-3.498C12.495 22.17 11.05 16.06 9 9H5.79C4.324 9 3.054 7.938 3.007 6.472a15 15 0 0 1 0-.944M34 41a4 4 0 1 0 8 0a4 4 0 0 0-8 0m-20 0a4 4 0 1 0 8 0a4 4 0 0 0-8 0m19-18.5H23m5-5v10\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shoppingCartAdd
